export interface User {
  id: number;
  name: string;
  firstName?: string;
  lastName?: string;
  email: string;
  zipCode?: string;
  bio?: string;
  created_at: string;
  updated_at: string;
  phoneNumber?: string;
  phoneVerified?: boolean;
}

/**
 * Helper to get display name from a user object.
 * Prefers firstName/lastName if available, falls back to name.
 */
export function getDisplayName(user: { name?: string; firstName?: string; lastName?: string } | null | undefined): string {
  if (!user) {
    return '';
  }
  if (user.firstName || user.lastName) {
    return `${user.firstName || ''} ${user.lastName || ''}`.trim();
  }
  return user.name || '';
}